import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useSite } from "@/lib/site";
import Seo from "@/components/Seo";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  const { site } = useSite();
  const CONTACT = { ...(site.contact || {}), phone1: site.contact?.phone1 || "", phone2: site.contact?.phone2 || "", email: site.contact?.email || "", address: site.contact?.address || "", hours: site.contact?.hours || [] };

  return (
    <div data-testid="contact-page">
      <Seo title="Contact" description="Call +91 98087 24448 or email hubdigisolution@gmail.com. Visit us in Rishikesh, Uttarakhand. Free consultation for IT, marketing and web design projects." />
      <section className="hero-gradient text-white">
        <div className="container-x py-20 md:py-24 text-center">
          <div className="chip-light mx-auto">Call to Us</div>
          <h1 className="mt-4 text-4xl md:text-6xl">Let's <span className="text-[color:var(--dh-orange)]">talk business.</span></h1>
          <p className="mt-5 text-white/80 max-w-xl mx-auto leading-relaxed">
            Reach out for a free consultation. Our team is here Monday to Sunday to help you plan your next move.
          </p>
        </div>
      </section>

      <section className="container-x py-16 grid lg:grid-cols-[1.1fr_1fr] gap-10">
        {/* Info cards */}
        <div className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            {[
              { i: Phone, t: "Phone", v: [CONTACT.phone1, CONTACT.phone2], href: `tel:${CONTACT.phone1.replace(/\s/g, "")}` },
              { i: Mail, t: "Email", v: [CONTACT.email], href: `mailto:${CONTACT.email}` },
            ].map(({ i: Icon, t, v, href }) => (
              <a key={t} href={href} className="p-6 rounded-2xl border border-[color:var(--dh-line)] hover:border-[color:var(--dh-orange)] transition-colors bg-white block" data-testid={`contact-info-${t.toLowerCase()}`}>
                <div className="w-11 h-11 rounded-xl bg-[color:var(--dh-orange)]/15 text-[color:var(--dh-orange)] grid place-items-center"><Icon className="w-5 h-5" /></div>
                <div className="mt-3 font-display text-lg text-[color:var(--dh-navy)]">{t}</div>
                {v.filter(Boolean).map((x, idx) => <div key={`${t}-${idx}-${x}`} className="text-sm text-[color:var(--dh-slate)]">{x}</div>)}
              </a>
            ))}
          </div>

          <div className="p-6 rounded-2xl border border-[color:var(--dh-line)] bg-white">
            <div className="flex gap-3">
              <div className="w-11 h-11 rounded-xl bg-[color:var(--dh-orange)]/15 text-[color:var(--dh-orange)] grid place-items-center shrink-0"><MapPin className="w-5 h-5" /></div>
              <div>
                <div className="font-display text-lg text-[color:var(--dh-navy)]">Visit Our Office</div>
                <div className="text-sm text-[color:var(--dh-slate)] mt-1">{CONTACT.address}</div>
              </div>
            </div>
          </div>

          <div className="p-6 rounded-2xl border border-[color:var(--dh-line)] bg-white">
            <div className="flex gap-3">
              <div className="w-11 h-11 rounded-xl bg-[color:var(--dh-orange)]/15 text-[color:var(--dh-orange)] grid place-items-center shrink-0"><Clock className="w-5 h-5" /></div>
              <div className="flex-1">
                <div className="font-display text-lg text-[color:var(--dh-navy)]">Business Hours</div>
                <ul className="mt-2 space-y-1 text-sm">
                  {CONTACT.hours.map((h) => (
                    <li key={h.day} className="flex justify-between text-[color:var(--dh-slate)]"><span>{h.day}</span><span className="text-[color:var(--dh-navy)] font-semibold">{h.time}</span></li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden border border-[color:var(--dh-line)] h-[240px]">
            <iframe
              title="Digi Hub Solution Location"
              src="https://www.google.com/maps?q=Devender+Vihar+Gumaniwala+Rishikesh&output=embed"
              width="100%" height="100%" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <ContactForm />
      </section>

    </div>
  );
}
